(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gyao-recipe-ai"] && !Shopify.designMode) return;
  try {
    
(()=>{document.querySelectorAll('.gyao-ai').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='1';const endpoint=root.dataset.endpoint,form=root.querySelector('[data-form]'),modeInput=root.querySelector('[data-mode-input]'),status=root.querySelector('[data-status]'),results=root.querySelector('[data-results]'),submit=root.querySelector('[data-submit]'),photo=root.querySelector('[data-photo]'),photoName=root.querySelector('[data-photo-name]');const visitor=(()=>{const key='gyao_recipe_visitor';try{let id=localStorage.getItem(key);if(!id){id=crypto.randomUUID();localStorage.setItem(key,id)}return id}catch(e){return crypto.randomUUID?crypto.randomUUID():Date.now().toString(36)+Math.random().toString(36).slice(2)+Math.random().toString(36).slice(2)}})();let products=[];try{products=JSON.parse(root.querySelector('[data-products]').textContent)}catch(e){}const productMap=new Map(products.map(p=>[p.handle,p]));const show=(m,err=false)=>{status.hidden=false;status.textContent=m;status.style.color=err?'#ffaaaa':''};const track=(event,data={})=>{window.dataLayer=window.dataLayer||[];window.dataLayer.push({event,...data})};root.querySelectorAll('[data-mode]').forEach(btn=>btn.addEventListener('click',()=>{const mode=btn.dataset.mode;modeInput.value=mode;root.querySelectorAll('[data-mode]').forEach(b=>b.classList.toggle('is-active',b===btn));root.querySelectorAll('[data-panel]').forEach(p=>p.hidden=p.dataset.panel!==mode);results.hidden=true;status.hidden=true}));photo?.addEventListener('change',()=>photoName.textContent=photo.files?.[0]?.name||'');const imageData=file=>new Promise((res,rej)=>{const url=URL.createObjectURL(file),img=new Image();img.onerror=()=>{URL.revokeObjectURL(url);rej(new Error('Could not read that image.'))};img.onload=()=>{try{const max=1024,scale=Math.min(1,max/Math.max(img.width,img.height)),w=Math.max(1,Math.round(img.width*scale)),h=Math.max(1,Math.round(img.height*scale)),canvas=document.createElement('canvas');canvas.width=w;canvas.height=h;const ctx=canvas.getContext('2d');ctx.drawImage(img,0,0,w,h);URL.revokeObjectURL(url);res(canvas.toDataURL('image/jpeg',.72))}catch(e){URL.revokeObjectURL(url);rej(e)}};img.src=url});const el=(tag,text,cls)=>{const x=document.createElement(tag);if(cls)x.className=cls;if(text!==undefined)x.textContent=text;return x};const productCard=handle=>{const p=productMap.get(handle);if(!p)return null;const box=el('aside',undefined,'gyao-ai__product');if(p.image){const img=el('img');img.src=p.image;img.alt=p.title;box.appendChild(img)}const body=el('div');body.appendChild(el('h3',p.title));body.appendChild(el('p',p.price));const b=el('button',p.available?'Add to cart':'View product','gyao-ai__buy');b.type='button';b.addEventListener('click',async()=>{if(!p.available){location.href=p.url;return}b.disabled=true;b.textContent='Adding...';try{const rr=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:p.variantId,quantity:1}]})});if(!rr.ok)throw 0;b.textContent='Added ✓';track('recipe_add_to_cart',{product_handle:p.handle})}catch(e){b.disabled=false;b.textContent='View product';b.onclick=()=>location.href=p.url}});body.appendChild(b);box.appendChild(body);return box};const call=async payload=>{if(!endpoint){show('The hidden storefront is ready. The Cloudflare recipe backend still needs to be connected before recipes can generate.',true);return}submit.disabled=true;show('Cooking up something good...');try{const r=await fetch(endpoint,{method:'POST',headers:{'Content-Type':'application/json','X-GYAO-Visitor':visitor},body:JSON.stringify(payload)}),data=await r.json();if(!r.ok)throw new Error(data.error||'Recipe request failed');status.hidden=true;results.innerHTML='';results.hidden=false;if(Array.isArray(data.suggestions)){results.appendChild(el('h2','Here’s what you can make'));const grid=el('div',undefined,'gyao-ai__cards');data.suggestions.forEach(s=>{const c=el('article',undefined,'gyao-ai__card');c.appendChild(el('h3',s.title));c.appendChild(el('p',s.description||''));const b=el('button','Make this');b.type='button';b.addEventListener('click',()=>call({...payload,action:'recipe',selectedSuggestion:s}));c.appendChild(b);grid.appendChild(c)});results.appendChild(grid)}else if(data.recipe){const rcp=data.recipe,grid=el('div',undefined,'gyao-ai__recipe'),copy=el('article');copy.appendChild(el('h2',rcp.title));if(rcp.summary)copy.appendChild(el('p',rcp.summary));const meta=el('div');[['Serves ',rcp.servings],['Prep ',rcp.prepMinutes&&rcp.prepMinutes+' min'],['Cook ',rcp.cookMinutes&&rcp.cookMinutes+' min']].forEach(v=>{if(v[1])meta.appendChild(el('span',v[0]+v[1],'gyao-ai__pill'))});copy.appendChild(meta);const addList=(title,items,ordered=false)=>{if(!items?.length)return;copy.appendChild(el('h3',title));const l=el(ordered?'ol':'ul');items.forEach(i=>l.appendChild(el('li',i)));copy.appendChild(l)};addList('Ingredients',rcp.ingredients);addList('How to cook it',rcp.steps,true);if(rcp.internalTemperature){copy.appendChild(el('h3','Temperature check'));copy.appendChild(el('p',rcp.internalTemperature))}addList('Good to know',rcp.notes);grid.appendChild(copy);const pc=productCard(rcp.productHandle);if(pc)grid.appendChild(pc);results.appendChild(grid);track('recipe_generated',{recipe_title:rcp.title||'',product_handle:rcp.productHandle||''})}else throw new Error('Unexpected recipe response');results.scrollIntoView({behavior:'smooth',block:'start'})}catch(e){show(e.message||'Something went sideways. Try again.',true)}finally{submit.disabled=false}};form.addEventListener('submit',async e=>{e.preventDefault();const d=new FormData(form),mode=d.get('mode');let prompt=String(d.get(mode+'_prompt')||'').trim();if(mode==='seasoning')prompt=String(d.get('seasoning_prompt')||'').trim();if(!prompt&&mode!=='seasoning'){show('Give us something to work with first.',true);return}if(mode==='seasoning'&&!d.get('seasoning_handle')){show('Pick the GYAO seasoning you have first.',true);return}const payload={action:mode==='pantry'?'suggest':'recipe',mode,prompt,method:d.get('method'),time:d.get('time'),servings:Number(d.get('servings')||4),seasoningHandle:d.get('seasoning_handle')||null,allowedProducts:products.map(p=>({handle:p.handle,title:p.title}))};if(mode==='pantry'&&photo?.files?.[0])payload.image=await imageData(photo.files[0]);track('recipe_started',{recipe_mode:mode});call(payload)})})})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
